import React from "react";
import { Link } from "react-router-dom";
import "../style/SignedIn.css";
const SignedIn = () => {
  return (
    <div className="signed-in-banner animate-in">
      <h1>Welcome back</h1>
      <div className="icon" />
      <h2>Browse with unlimited access</h2>
      <p>
        Want to see all the music we have?{" "}
        <Link to="/overview">Click here</Link>
      </p>
    </div>
  );
};

export default SignedIn;



// WEBPACK FOOTER //
// ./src/components/SignedIn.js